import React from "react";
import NiceModal from "@ebay/nice-modal-react";
import {Box, Colors, Text} from "@bounce/shared/ui";
import {
  PAYMENT_METHOD_DISPLAY_FLOW_TYPE,
  PaymentMethod,
  PaymentMethodDisplayPolicy,
} from "../../../apis/requests/payment-flows/types";
import {Tooltip} from "../../../ui/components";
import PaymentFlowsList from "../PaymentFlowsList";
import {PAYMENT_METHOD_OPTIONS} from "./constants";
import DisplayTestDialog from "./DisplayTestDialog";

const TILE_WIDTH = 28;
const TILE_HEIGHT = 24;
const TILE_RADIUS = "5px";
const TILE_ICON_SIZE = 16;

const DELETE_COPY = {
  title: "Delete display test",
  warning: "Checkouts that currently match this test will fall through to the next matching test, usually the default.",
};

const EDITOR = {
  addLabel: "+ Add display test",
  open: (flowId?: number) => NiceModal.show(DisplayTestDialog, {flowId}),
};

const MethodTile = ({method, isDefault}: {method: PaymentMethod; isDefault: boolean}) => {
  const {label, Icon} = PAYMENT_METHOD_OPTIONS[method];
  const title = isDefault ? `${label} · default` : label;
  return (
    <Tooltip title={title}>
      <Box
        aria-label={title}
        sx={{
          width: TILE_WIDTH,
          height: TILE_HEIGHT,
          borderRadius: TILE_RADIUS,
          border: `1px solid ${isDefault ? Colors.blue._800 : Colors.tertiary._300}`,
          backgroundColor: isDefault ? Colors.blue._100 : "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: Colors.grey._900,
        }}
      >
        <Icon sx={{fontSize: TILE_ICON_SIZE}} />
      </Box>
    </Tooltip>
  );
};

const MethodOrder = (policy: PaymentMethodDisplayPolicy) => (
  <Box sx={{display: "flex", alignItems: "center", gap: 0.75}}>
    {policy.methods.map((method) => (
      <MethodTile key={method} method={method} isDefault={method === policy.default} />
    ))}
    <Text size={12} sx={{color: Colors.grey._600, ml: 0.5}}>
      {`default: ${PAYMENT_METHOD_OPTIONS[policy.default].label}`}
    </Text>
  </Box>
);

const PaymentMethodDisplayPage = () => (
  <PaymentFlowsList
    type={PAYMENT_METHOD_DISPLAY_FLOW_TYPE}
    title="Payment method display"
    noRowsText="No display tests yet"
    loadErrorText="Failed to load display tests."
    deleteCopy={DELETE_COPY}
    renderPolicy={MethodOrder}
    editor={EDITOR}
  />
);

export default PaymentMethodDisplayPage;
